export default {
  searchTerm: '',
  completionTerms: [],
  mobileOpen: false,
  submitting: false,
};
